var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokeIconBallade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4932 11.0193C22.3528 8.36566 22.4023 6.18939 21.9155 4.50341C21.1553 1.87046 19.0973 0.5 16.9967 0.5C14.896 0.5 12.8385 1.87053 12.0795 4.50362C11.5939 6.18801 11.6438 8.36175 12.5023 11.0119C10.637 8.94433 8.7799 7.81486 7.07873 7.39352C4.4191 6.73479 2.20355 7.83163 1.15298 9.65068C0.102422 11.4697 0.259544 13.9369 2.15878 15.9114C3.37419 17.1749 5.28135 18.2193 8.00576 18.8013C5.2791 19.3832 3.37037 20.4277 2.15395 21.6915C0.253593 23.6658 0.0957553 26.1331 1.14639 27.9523C2.19701 29.7714 4.41315 30.8681 7.07374 30.2095C8.77762 29.7876 10.638 28.656 12.5068 26.5837C11.6472 29.2373 11.5977 31.4136 12.0845 33.0996C12.8447 35.7325 14.9027 37.103 17.0033 37.103C19.104 37.103 21.1615 35.7324 21.9205 33.0994C22.4059 31.4156 22.3562 29.2429 21.4987 26.5941C23.3636 28.6619 25.2203 29.7916 26.9212 30.2131C29.5809 30.8723 31.7965 29.7751 32.8471 27.9555C33.8975 26.136 33.7405 23.668 31.8413 21.6929C30.6258 20.4289 28.7185 19.384 25.9938 18.8018C28.7207 18.2199 30.6296 17.1753 31.846 15.9115C33.7464 13.9371 33.9042 11.4698 32.8536 9.65068C31.803 7.83153 29.5869 6.73484 26.9263 7.39351C25.2224 7.81533 23.362 8.94697 21.4932 11.0193Z",
    fill: "#1DDFEC",
    stroke: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeIconBallade);
export default __webpack_public_path__ + "static/media/stroke-icon-ballade.923e2cbc6ef33df8fdf76fe23c24d7bb.svg";
export { ForwardRef as ReactComponent };